/**
 * Format phone number
 * @param {string} phone
 * @returns {string}
 * @example
 * formatPhoneNumber('1234567890') // => (12) 3456-7890
 * formatPhoneNumber('12345678901') // => (12) 34567-8901
 * */
export const formatPhoneNumber = (phone: string) => {
  const stripped = phone.replace(/[\s-()]/g, '');

  if (stripped.length > 0) {
    const cutIndex = stripped.length === 11 ? 7 : 6;

    const prefix = stripped.slice(0, 2);
    const firstHalf = stripped.slice(2, cutIndex);
    const lastHalf = stripped.slice(cutIndex);

    return `(${prefix}) ${firstHalf}-${lastHalf}`;
  }

  return '';
};
